import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga'
import appReducer from './reducers';
import userSlice from './auth/login/userSlice';
import { rootSaga } from 'saga-slice';
import appSaga from './sagas';
import dataSlice from '../modules/dataSlice';
import coeffAbattEvSlice from '../modules/parametrage/CeofficiantAbattement/coeffAbattSlice';
import coeffAbattKmSlice from '../modules/parametrage/CoefficiantRelatif/coeffAbattKmSlice';
import parametrageSlice from '../modules/parametrage/ValeurVinal/parametrageSlice';
import vehiculeSlice from '../modules/database/vehiculeSlice';
import clientSlice from '../modules/database/clientSlice';
import vvinaleSlice from '../modules/valeurVinal/vvinaleSlice';

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const modules = [ userSlice,dataSlice,parametrageSlice, coeffAbattEvSlice, coeffAbattKmSlice, vehiculeSlice, clientSlice, vvinaleSlice];

const store = createStore(appReducer, composeEnhancers(applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(rootSaga(modules));
sagaMiddleware.run(appSaga);

export default store;